export default "__VITE_ASSET__d94a434c__"